module.exports = __webpack_public_path__ + "public/img/Merancang Desain Konten Untuk Desainer Grafis.deb77bbc.png";